export default __webpack_public_path__ + "static/media/sbo-title-en.efdf0953.webp";